import React from 'react';

import "./Czk.scss";

export const Czk = (props) => {
  const { value, decimal, children } = props;

  const num = Number.jet.to(value);
  const str = num.toLocaleString(undefined, {
    maximumFractionDigits: decimal,
  })

  return (
    <span className="Czk">
      {`${str} Kč`}
    </span>
  )
}

